import React from 'react';
import Axios from 'axios';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody} from 'reactstrap';

import TeamDropdown from '../../shared/TeamsDropdown';
import PlayersDropdownScoresheet from '../../shared/PlayersDropdownScoresheet';
import WeeksDropdown from '../../shared/WeeksDropdown';
import SeasonsDropdown from '../../shared/SeasonsDropdown';
import SubSeasonsDropdown from '../../shared/SubSeasonsDropdown';
import RoundScore from './RoundScore';
import Scoreboard_8B from './Scoreboards/Scoreboard_8B';
import Scoreboard_9B from './Scoreboards/Scoreboard_9B';
import Scoreboard_10B from './Scoreboards/Scoreboard_10B';
import HandicapTypeSelect from '../../shared/Tools/HandicapTypeSelect';

import moment from 'moment';
import * as myConstClass from '../../shared/constants/constants';


class ScoresheetEdit extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			ssftype: 0,
			scoresheetData: {           // some array-data must be pre-initialized to prevent undefined errors
				scoresheetEditId: '0',
				playersIdTeam1: [],
				playersIdTeam2: [],
				playersHandicapTeam1: [],
				playersHandicapTeam2: [],
				rounds: [],
				season: {
					special: ""
				},
				scoresheetFormat: {
					winPoints: 10,
				},
				teams: [],
				subPlayers: [[], []],
				playersTeam1: [],
				playersTeam2: [],
				specialTable: []
			},

			team1totalEro: 0,
			team2totalEro: 0,
			team1totalTbb: 0,
			team2totalTbb: 0,
			team1totalTv: 0,
			team2totalTv: 0,
			scoreChanged: false,

			teamOrder: 'A',
			savingInProgress: false,
		};
	
		this.loadScoresheet = this.loadScoresheet.bind(this);
		this.setScoresheetResults = this.setScoresheetResults.bind(this);
		this.checkAndAddMissingPlayers = this.checkAndAddMissingPlayers.bind(this);
		this.subSeasonChange = this.subSeasonChange.bind(this);
		this.dateChange = this.dateChange.bind(this);
		this.weekChange = this.weekChange.bind(this);
		this.handicapTypeChange = this.handicapTypeChange.bind(this);
		this.handicapMaxChange = this.handicapMaxChange.bind(this);
		this.ssfTypeChange = this.ssfTypeChange.bind(this);
		this.activeTeamChange1 = this.activeTeamChange1.bind(this);
		this.activeTeamChange2 = this.activeTeamChange2.bind(this);
		this.setPlayersList = this.setPlayersList.bind(this);
		this.playerChange = this.playerChange.bind(this);
		this.handicapChange = this.handicapChange.bind(this);
		this.eroChange = this.eroChange.bind(this);
		this.tbbChange = this.tbbChange.bind(this);
		this.tvChange = this.tvChange.bind(this);
		this.handleScoreChange = this.handleScoreChange.bind(this);
		this.scoreChange = this.scoreChange.bind(this);
		this.handleScoreBlur = this.handleScoreBlur.bind(this);
		this.scoreBlur = this.scoreBlur.bind(this);
		this.scoreKeyPress = this.scoreKeyPress.bind(this);
		this.updateScores = this.updateScores.bind(this);
		this.updateSpecialStats = this.updateSpecialStats.bind(this);
		this.handleCompiledChange = this.handleCompiledChange.bind(this);
		this.handleSaveClick = this.handleSaveClick.bind(this);
		this.displayInstructions = this.displayInstructions.bind(this);
		this.orderTeam = this.orderTeam.bind(this);
		this.scoreKeyPress = this.scoreKeyPress.bind(this);
		this.dispScoresheetTypeSelect = this.dispScoresheetTypeSelect.bind(this);
		this.displayScoreboard = this.displayScoreboard.bind(this);
		this.dispCompiledButton = this.dispCompiledButton.bind(this);
		this.createPlayerDropDownTeam1 = this.createPlayerDropDownTeam1.bind(this);
		this.createPlayerDropDownTeam2 = this.createPlayerDropDownTeam2.bind(this);
		this.savingModal = this.savingModal.bind(this);
		
		this.dispSpecialPanel = this.dispSpecialPanel.bind(this);
		this.createSpecialTableRow = this.createSpecialTableRow.bind(this);
		this.handleAddSpecialTableEntry = this.handleAddSpecialTableEntry.bind(this);
		this.handleDeleteSpecialTableRow = this.handleDeleteSpecialTableRow.bind(this);
	}

	componentDidMount() {
		// console.log('ScoresheetEdit: componentDidMount');
		// console.log('this.props.scoresheetEditId: ', this.props.scoresheetEditId);
		this.loadScoresheet(this.props.season._id, this.state.ssftype, false);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('ScoresheetEdit: UNSAFE_componentWillReceiveProps');
		// console.log('this.props.scoresheetEditId: ', nextProps.scoresheetEditId);
		this.loadScoresheet(nextProps.season._id, this.state.ssftype, false);
	}

	loadScoresheet(seasonId, ssftype, ssftypeChange) {
		//console.log('ScoresheetEdit: loadScoresheet - seasonId: ', seasonId);

		// ScoresheetData: initiate new scoresheet data
		// Get SeasonInfo, SubPlayers, ScoresheetFormat, Teams, WeekMax for each subSeason 
		var _this = this;
		var scoresheetEditId = this.props.scoresheetEditId;

		if (seasonId !== "0") {
		if (ssftypeChange) {
			scoresheetEditId = '0';
		}

		// get Scoresheet if editing
		Axios.get('/api/scoresheets/' + scoresheetEditId).then(function(response) {

			var scoresheetResults = response.data;
			if (scoresheetEditId !== '0') {
				ssftype = scoresheetResults.ssftype;
			}

			Axios.get('/api/seasons/' + seasonId + '/SeasonAndScoresheetInfo/ssftype/' + ssftype).then(function(response) {

				var scoresheetData = response.data;
				scoresheetData.ssftype = ssftype;

				var date = new Date();
				// date = moment(date.toISOString()).utc().format("YYYY-MM-DD");
				date = moment(date.toISOString()).format("YYYY-MM-DD");
				
				scoresheetData.date = date;
				scoresheetData.compiled = false;

				scoresheetData.seasonId = scoresheetData.season._id;
				scoresheetData.subSeasons = scoresheetData.season.subSeasons;

				// Sort subSeasons by Id, to display last one
				scoresheetData.subSeasons.sort(function(a,b) {
					return (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0);} 
				);

				scoresheetData.subSeasonId = scoresheetData.season.subSeasons[scoresheetData.season.subSeasons.length - 1].id;
				scoresheetData.week = scoresheetData.subSeasonsMaxWeeks[scoresheetData.season.subSeasons.length - 1];
				scoresheetData.nbMatchEq = scoresheetData.season.nbMatchEq;

				// save these properties to have them in scoresheetsController
				scoresheetData.stateloLeagueParam = scoresheetData.season.stateloLeagueParam;
				scoresheetData.handicapType = scoresheetData.season.handicapType;
				scoresheetData.handicapMax = scoresheetData.season.handicapMax;
				scoresheetData.leagueType = scoresheetData.season.leagueType;
				scoresheetData.resultsType = scoresheetData.season.resultsType;
				scoresheetData.formatTeamIndiv = scoresheetData.season.formatTeamIndiv;
				scoresheetData.formatRoundPts = scoresheetData.season.formatRoundPts;
				scoresheetData.formatMatchPoint = scoresheetData.season.formatMatchPoint;
				scoresheetData.formatMatchType = scoresheetData.season.formatMatchType;

				scoresheetData.scoresheetEditId = '0';
				//scoresheetData.teams = scoresheetData.teams;
				
				// error when no scoresheet format created
				scoresheetData.rounds = [];
				
				if (scoresheetData.scoresheetFormat !== null) {
					scoresheetData.rounds = scoresheetData.scoresheetFormat.rounds;
				}

				// Prevent 0 scores to be Nan (empty "" inits in some scoresheetFormats)
				scoresheetData.rounds.forEach(function(round) {
					round.matchups.forEach(function(matchup) {
						if (matchup.p1Score === "") {matchup.p1Score = 0;}
						if (matchup.p2Score === "") {matchup.p2Score = 0;}
					});
				});

				// console.log('scoresheetData.rounds');
				// console.log(scoresheetData.rounds);

				// #PP# validate if still needed
				scoresheetData.playersIdTeam1 = [];         // PP: needed here to prevent Warning of uncontrolled input in PlayersDropdownScoresheet
				scoresheetData.playersIdTeam2 = [];         // PP: needed here to prevent Warning of uncontrolled input in PlayersDropdownScoresheet

				// Default init to 0 handicap to prevent null in db
				scoresheetData.playersHandicapTeam1 = [];   // playersHandicapTeam1,
				scoresheetData.playersHandicapTeam2 = [];   // playersHandicapTeam2,

				var playerTeamsData = {};
				var teamId1 = '0';
				var teamId2 = '0';

				if(scoresheetData.teams.length > 0) {
					teamId1 = scoresheetData.teams[0]._id;
				
					if(scoresheetData.teams.length > 1) {
						teamId2 = scoresheetData.teams[1]._id;
					} else {
						teamId2 = scoresheetData.teams[0]._id;
					}
				}

				playerTeamsData = _this.initPlayersList(teamId1, scoresheetData);
				scoresheetData.team1Id = playerTeamsData.teamId;
				scoresheetData.playersIdTeam1 = playerTeamsData.playersIdTeam;
				scoresheetData.playersTeam1 = playerTeamsData.players;
				scoresheetData.playersHandicapTeam1 = playerTeamsData.playersHandicapTeam;

				playerTeamsData = _this.initPlayersList(teamId2, scoresheetData);
				scoresheetData.team2Id = playerTeamsData.teamId;
				scoresheetData.playersIdTeam2 = playerTeamsData.playersIdTeam;
				scoresheetData.playersTeam2 = playerTeamsData.players;
				scoresheetData.playersHandicapTeam2 = playerTeamsData.playersHandicapTeam;

				// parse subPlayers and remove regular ones from teams
				scoresheetData.subPlayers = _this.setSubPlayersLists(scoresheetData);

				if (scoresheetData.specialTable == null) {
					scoresheetData.specialTable = [];
				}

				if (scoresheetEditId !== '0') {
					_this.setScoresheetResults(scoresheetData, scoresheetEditId, scoresheetResults);
				} else {
					_this.updateScores(scoresheetData);
				}
			});
		});
		}
	}

	initPlayersList(teamId, scoresheetData) {
		var dataOut = {};
		var teamFind;

		scoresheetData.teams.forEach(function(team) {
			if (team._id === teamId) {
				teamFind = team;
			}
		});

		var playersIdTeam = [];
		var defaultHandicaps = [];
		for (var plIdx = 0; plIdx < scoresheetData.scoresheetFormat.nbPlayersPerTeam; plIdx++) {
			if (plIdx < teamFind.players.length) {
				playersIdTeam.push(teamFind.players[plIdx].playerId);
			} else {
				if (teamFind.players.length >= 1) {
					playersIdTeam.push(teamFind.players[0].playerId);
				}
			}
			defaultHandicaps.push(0);
		}

		dataOut.teamId = teamFind._id;
		dataOut.playersIdTeam = playersIdTeam;
		dataOut.players = teamFind.players;
		dataOut.playersHandicapTeam = defaultHandicaps;

		return dataOut;
	}

	setSubPlayersLists(scoresheetData) {
		var subPlayers = [];
		var subPlayers1 = [];
		var subPlayers2 = [];
		var foundPlayer = false;

		scoresheetData.season.subPlayers.forEach(function(spitem) {

			// sub players for team 1
			foundPlayer = false;
			scoresheetData.playersTeam1.forEach(function (plitem) {
				if (plitem.playerId.toString() === spitem.playerId.toString()) {
					foundPlayer = true;
				}
			});
			if (!foundPlayer) {
				subPlayers1.push(spitem);
			}

			//console.log('setSubPlayersLists')
			//console.log(scoresheetData.playersTeam2)

			// sub players for team 2
			foundPlayer = false;
			scoresheetData.playersTeam2.forEach(function (plitem) {
				if (plitem.playerId.toString() === spitem.playerId.toString()) {
					foundPlayer = true;
				}
			});
			if (!foundPlayer) {
				subPlayers2.push(spitem);
			}
		})

		subPlayers.push(subPlayers1, subPlayers2)
		return subPlayers;
	}

	setScoresheetResults(scoresheetData, scoresheetEditId, scoresheetResults) {

		// Init to scoresheetFormat data first
		var _this = this;
		var rounds = scoresheetData.rounds;

		// Append results
		rounds.forEach(function(round, roundIdx) {
			round.matchups.forEach(function(matchup, matchupIdx) {

				// Validation: 
				// Check if roundIdx > results number of rounds
				if (roundIdx > (scoresheetResults.rounds.length - 1)) {
					// console.log('ScoresheetEdit: Adjusting rounds length error')
					matchup.p1Score = 0;
					matchup.p2Score = 0;
					matchup.ero = false;
					matchup.tbb = false;
					matchup.tv = false;

				} else {
				
					// Check if matchupIdx > results number of matchups
					if (matchupIdx > (scoresheetResults.rounds[roundIdx].matchups.length - 1)) {
						// console.log('ScoresheetEdit: Adjusting matchups length error')
						matchup.p1Score = 0;
						matchup.p2Score = 0;
						matchup.ero = false;
						matchup.tbb = false;
						matchup.tv = false;

					} else {

						// Everything ok, get data
						var resultsMatchup = scoresheetResults.rounds[roundIdx].matchups[matchupIdx];
						matchup.p1Score = parseInt(resultsMatchup.p1Score, 10);
						matchup.p2Score = parseInt(resultsMatchup.p2Score, 10);
						matchup.ero = resultsMatchup.ero;
						matchup.tbb = resultsMatchup.tbb;
						matchup.tv = resultsMatchup.tv;
					}
				}
			});
		});

		// Load scoresheet Results
		scoresheetData.week = scoresheetResults.week;
		scoresheetData.date = moment(scoresheetResults.date).utc().format("YYYY-MM-DD");
		scoresheetData.seasonId = scoresheetResults.seasonId;
		scoresheetData.subSeasonId = scoresheetResults.subSeasonId;
		scoresheetData.team1Id = scoresheetResults.team1Id;
		scoresheetData.team2Id = scoresheetResults.team2Id;
		scoresheetData.handicapType = scoresheetResults.handicapType;

		// Patch for handicapTypes not set in scoresheet we edit (created from previous method)
		if (scoresheetResults.handicapMax !== undefined) {
			scoresheetData.handicapMax = scoresheetResults.handicapMax;
		} else {
			scoresheetData.handicapMax = scoresheetData.season.handicapMax;
		}

		scoresheetData.playersTeam1 = _this.getTeamPlayers(scoresheetData.team1Id, scoresheetData.teams);
		scoresheetData.playersTeam2 = _this.getTeamPlayers(scoresheetData.team2Id, scoresheetData.teams);

		scoresheetData.playersIdTeam1 = scoresheetResults.playersIdTeam1;
		scoresheetData.playersIdTeam2 = scoresheetResults.playersIdTeam2;

		// ********************************************
		// Exception to insert/consider players that have been removed from team in season

		_this.checkAndAddMissingPlayers(scoresheetData, 1, function(scoresheetData) {
		_this.checkAndAddMissingPlayers(scoresheetData, 2, function(scoresheetData) {

			scoresheetData.subPlayers = _this.setSubPlayersLists(scoresheetData);

			// Prevent null values in handicap fields (problems with previous scoresheet savings)
			scoresheetData.playersHandicapTeam1 = scoresheetResults.playersHandicapTeam1;
			scoresheetData.playersHandicapTeam1.forEach(function(hdcpElem, hdcpIdx, hdcpArray) {
				if (hdcpElem === null) { hdcpArray[hdcpIdx] = 0; }
			});

			scoresheetData.playersHandicapTeam2 = scoresheetResults.playersHandicapTeam2;
			scoresheetData.playersHandicapTeam2.forEach(function(hdcpElem, hdcpIdx, hdcpArray) {
				if (hdcpElem === null) { hdcpArray[hdcpIdx] = 0; }
			});

			scoresheetData.rounds = rounds;
			scoresheetData.scoresheetEditId = scoresheetEditId;
			scoresheetData.compiled = scoresheetResults.compiled;

			scoresheetData.specialTable = scoresheetResults.specialTable;
			if (scoresheetData.specialTable == null) {
				scoresheetData.specialTable = [];
			}

			_this.updateScores(scoresheetData);
		});
		});
	}

	checkAndAddMissingPlayers(scoresheetData, teamNumber, callback) {
		var resultsPlayers = [];
		var teamPlayers = [];
		var _this = this;

		if (teamNumber === 1) {
			resultsPlayers = scoresheetData.playersIdTeam1;
			teamPlayers = scoresheetData.playersTeam1;
		} else {
			resultsPlayers = scoresheetData.playersIdTeam2;
			teamPlayers = scoresheetData.playersTeam2;
		}

		// Exception to insert/consider players that have been removed from team in season
		var nbItems = resultsPlayers.length;
		var itemsProcessed = 0;
		resultsPlayers.forEach(function (piditem) {

			var foundPlayerId = false;
			teamPlayers.forEach(function (piditem2) {
				if (piditem.toString() === piditem2.playerId.toString()) {
					foundPlayerId = true;
				}
			});

			// 2019-01-15:  must check if found in subplayers (to avoid adding subplayers)
			scoresheetData.subPlayers[teamNumber - 1].forEach(function (piditem3) {
				if (piditem.toString() === piditem3.playerId.toString()) {
					foundPlayerId = true;
				}
			});

			if (!foundPlayerId) {
				console.log('ONE PLAYERID NOT FOUND, ADDED TEMPORARILY: ' + piditem);

				Axios.get('/api/players/playerid/' + piditem).then(function(response) {
					var playerToAdd = {
						playerId: piditem,
						name: response.data.firstname + ' ' + response.data.lastname,
					};

					// add missing player
					teamPlayers.push(playerToAdd);
					_this.setState({scoresheetData: scoresheetData});

					itemsProcessed++;
					if (itemsProcessed === nbItems) {
						callback(scoresheetData);
					}
				});

			} else {
				itemsProcessed++;
				if (itemsProcessed === nbItems) {
					callback(scoresheetData);
				}
			}
		});
	}

	getTeamPlayers(teamId, teams) {
		// console.log('ScoresheetEdit: getTeamPlayers: ' + teamId)
		var teamFind;
		teams.forEach(function(team) {
			if (team._id.toString() === teamId.toString()) {
				teamFind = team;
			}
		});
		return (teamFind.players);
	}

	handleSubmit(event) {
		event.preventDefault();     // do nothing on submit
	}

	subSeasonChange(subSeasonId) {
		var scoresheetData = this.state.scoresheetData;
		var subSeasonsMaxWeeks = scoresheetData.subSeasonsMaxWeeks;
		scoresheetData.subSeasonId = subSeasonId;

		// Set max number of weeks too
		scoresheetData.subSeasons.forEach(function(subSeasonItem, idx) {
			if(subSeasonId === subSeasonItem.id) {
				scoresheetData.week = subSeasonsMaxWeeks[idx];
			}
		});
		this.updateScores(scoresheetData);
	}

	dateChange(event) {
		var date = event.target.value;
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.date = date;
		this.updateScores(scoresheetData);
	}

	weekChange(week) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.week = week;
		this.updateScores(scoresheetData);
	}

	handicapTypeChange(handicapType) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.handicapType = handicapType;
		this.updateScores(scoresheetData);
	}

	handicapMaxChange(event) {
		var handicapMax = parseInt(event.target.value);
		var scoresheetData = this.state.scoresheetData;

		if (handicapMax < 0) {
			handicapMax = 0;
		}

		scoresheetData.handicapMax = handicapMax;
		this.updateScores(scoresheetData);
	}

	ssfTypeChange(event) {
		var confAns = true;
		if (this.state.scoresheetData.scoresheetEditId !== '0') {
			confAns = window.confirm("Changer le format de la feuille de pointage effacera les résultats actuels, voulez-vous continuer ?");
		}

		if (confAns) {
			var ssftype = parseInt(event.target.value, 10);
			this.loadScoresheet(this.props.season._id, ssftype, true);
		}
	}

	activeTeamChange1(team) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.team1Id = team;
		this.setState({
			scoresheetData: scoresheetData
		});
		this.setPlayersList(team, 1, scoresheetData);
	}

	activeTeamChange2(team) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.team2Id = team;
		this.setState({
			scoresheetData: scoresheetData
		});
		this.setPlayersList(team, 2, scoresheetData);
	}

	setPlayersList(teamId, teamNumber, scoresheetData) {
		var teamFind;
		scoresheetData.teams.forEach(function(team) {
			if (team._id === teamId) {
				teamFind = team;
			}
		});

		var playersIdTeam = [];
		for (var plIdx = 0; plIdx < scoresheetData.scoresheetFormat.nbPlayersPerTeam; plIdx++) {
			if (plIdx < teamFind.players.length) {
				playersIdTeam.push(teamFind.players[plIdx].playerId);
			} else {
				playersIdTeam.push(teamFind.players[0].playerId);
			}
		}

		// AUTOLOAD COTES ?
		// console.log('AUTOLOAD COTES: setPlayersList: ' + playersIdTeam.length);

		if (teamNumber === 1) {
			scoresheetData.team1Id = teamFind._id;
			scoresheetData.playersTeam1 = teamFind.players;
			scoresheetData.playersIdTeam1 = playersIdTeam;
		} else if (teamNumber === 2) {
			scoresheetData.team2Id = teamFind._id;
			scoresheetData.playersTeam2 = teamFind.players;

			scoresheetData.playersIdTeam2 = playersIdTeam;
		}

		scoresheetData.subPlayers = this.setSubPlayersLists(scoresheetData);

		this.setState({
			scoresheetData: scoresheetData,
		});
	}

	playerChange(player, teamNumber, playerNumber) {
		var scoresheetData = this.state.scoresheetData;

		// AUTOLOAD COTES
		// only when player change, manage also season, subseason, team, handicapType change
		// console.log('AUTOLOAD COTES: player change: ' + player);

		if (teamNumber === "1") {
			var playersIdTeam1 = scoresheetData.playersIdTeam1;
			playersIdTeam1[playerNumber - 1] = player;
			scoresheetData.playersIdTeam1 = playersIdTeam1;
		} else {
			var playersIdTeam2 = scoresheetData.playersIdTeam2;
			playersIdTeam2[playerNumber - 1] = player;
			scoresheetData.playersIdTeam2 = playersIdTeam2;
		}
		this.setState({
			scoresheetData: scoresheetData,
		});
	}

	handicapChange(handicap, teamNumber, playerNumber) {
		var scoresheetData = this.state.scoresheetData;
		var playersHandicapTeam1 = scoresheetData.playersHandicapTeam1;
		var playersHandicapTeam2 = scoresheetData.playersHandicapTeam2;

		if (teamNumber === "1") {
			playersHandicapTeam1[playerNumber - 1] = handicap;
		} else {
			playersHandicapTeam2[playerNumber - 1] = handicap;
		}

		// console.log('ScoresheetEdit: scoresheetData on handicapChange');
		// console.log(scoresheetData);
		this.updateScores(scoresheetData);
	}

	eroChange(event) {
		var matchInfo = event.target.name.split(".");
		var round = matchInfo[1];
		var game = matchInfo[2];
		var checked = event.target.checked;

		var scoresheetData = this.state.scoresheetData;
		var matchup = scoresheetData.rounds[round - 1].matchups[game - 1];
		matchup.ero = checked;
		this.updateScores(scoresheetData);
	}

	tbbChange(event) {
		var matchInfo = event.target.name.split(".");
		var round = matchInfo[1];
		var game = matchInfo[2];
		var checked = event.target.checked;

		var scoresheetData = this.state.scoresheetData;
		var matchup = scoresheetData.rounds[round - 1].matchups[game - 1];
		matchup.tbb = checked;
		this.updateScores(scoresheetData);
	}

	tvChange(event) {
		var matchInfo = event.target.name.split(".");
		var round = matchInfo[1];
		var game = matchInfo[2];
		var checked = event.target.checked;

		var scoresheetData = this.state.scoresheetData;
		var matchup = scoresheetData.rounds[round - 1].matchups[game - 1];
		matchup.tv = checked;
		this.updateScores(scoresheetData);
	}

	handleScoreChange(event) {
		var matchInfo = event.target.name.split(".");
		var player = matchInfo[0];
		var round = matchInfo[1];
		var game = matchInfo[2];

		event.target.value = parseInt(event.target.value, 10);
		var playerScore = event.target.value;
		this.scoreChange(player, round, game, playerScore);
	}

	scoreChange(player, round, game, playerScore) {
		// console.log('ScoresheetEdit: scoreChange');
		var scoresheetData = this.state.scoresheetData;
		var rounds = scoresheetData.rounds;
		var matchup = rounds[round - 1].matchups[game - 1];
		var leagueType = scoresheetData.leagueType;

		// standard leagues: score entered with numbers or Enter
		if(leagueType !== myConstClass.LGTYPE_10B) {

			if (player === "p1") {
				matchup.p1Score = playerScore;
			} else {
				matchup.p2Score = playerScore;
			}
		}

		this.setState({
			scoresheetData: scoresheetData,
			scoreChanged: true
		});

		this.updateSpecialStats(scoresheetData);
	}

	handleScoreBlur(event) {
		var matchInfo = event.target.name.split(".");
		var player = matchInfo[0];
		var round = matchInfo[1];
		var game = matchInfo[2];
		var playerScore = parseInt(event.target.value, 10);
		this.scoreBlur(player, round, game, playerScore);
	}

	scoreBlur(player, round, game, playerScore) {
		// console.log('ScoresheetEdit: scoreBlur');
		var scoresheetData = this.state.scoresheetData;
		var rounds = scoresheetData.rounds;
		var matchup = rounds[round - 1].matchups[game - 1];
		var winPoints = scoresheetData.scoresheetFormat.winPoints;
		var leagueType = scoresheetData.leagueType;

		// standard leagues: score entered with numbers or Enter
		if(leagueType !== myConstClass.LGTYPE_10B) {

			if ((winPoints !== 0) && (playerScore > winPoints)) {
				playerScore = winPoints;
			}

			if (player === "p1") {
				matchup.p1Score = playerScore;
				if ((winPoints !== 0) && (playerScore !== winPoints) && (playerScore !== 0) && (this.state.scoreChanged)) {
					matchup.p2Score = winPoints;
				}
				// another protection
				if (matchup.p2Score === undefined) {
					matchup.p2Score = 0;
				}
			} else {
				matchup.p2Score = playerScore;
				if ((winPoints !== 0) && (playerScore !== winPoints) && (playerScore !== 0) && (this.state.scoreChanged)) {
					matchup.p1Score = winPoints;
				}
				// another protection
				if (matchup.p1Score === undefined) {
					matchup.p1Score = 0;
				}
			}

			// DixZero score
			if (matchup.p1Score === 0 || matchup.p2Score === 0) {
				matchup.dixzero = true;
			} else {
				matchup.dixzero = false;
			}
		}

		this.updateScores(scoresheetData);
	}

	scoreKeyPress(event) {
		var matchInfo = event.target.name.split(".");
		var player = matchInfo[0];
		var round = matchInfo[1];
		var game = matchInfo[2];
		var key = event.key;
		var playerScore = parseInt(event.target.value, 10);
		var leagueType = this.state.scoresheetData.leagueType;

		// conditions for preventDefault behaviour
		if (((leagueType === myConstClass.LGTYPE_8B) && (key === "Enter")) ||
			((leagueType === myConstClass.LGTYPE_10B) && ((key === "1") || (key === "2"))) ||
			(key === "+")) {
				event.preventDefault();
		}

		var scoresheetData = this.state.scoresheetData;
		var rounds = scoresheetData.rounds;
		var matchup = rounds[round - 1].matchups[game - 1];
		var winPoints = scoresheetData.scoresheetFormat.winPoints;
		var leagueType = scoresheetData.leagueType;

		if (leagueType !== myConstClass.LGTYPE_10B) {

			// Enter key gives winPoints in standard leagues
			if (key === "Enter") {
				playerScore = winPoints;
			}
		} 

		if (leagueType === myConstClass.LGTYPE_10B) {

			// tenBall league special behaviour
			if (key === "1") {
				matchup.p1Score = 1;
				matchup.p2Score = 0;
			}
			if (key === "2") {
				matchup.p1Score = 0;
				matchup.p2Score = 1;
			}
		}

		// Any league, + key toggles ERO/TRO
		if (((leagueType === myConstClass.LGTYPE_8B) || (leagueType === myConstClass.LGTYPE_10B)) &&
				(key === "+")) {

			// Special behaviour for QVNEA leagues, managing the TV stat too
			if (this.state.scoresheetData.stateloLeagueParam.indexOf('QVNEA') !== -1) {
				if (!matchup.ero && !matchup.tv) {
					matchup.ero = true;
					matchup.tv = false;
				} else if (!matchup.ero && matchup.tv) {
					matchup.ero = false;
					matchup.tv = false;
				} else {
					matchup.ero = false;
					matchup.tv = true;
				}
			} else {
				matchup.ero = !matchup.ero;
			}
		}

		this.scoreChange(player, round, game, playerScore);
	}

	// ######################################################################################################################
	updateScores(scoresheetData) {
		//console.log('updateScores')
		//console.log(scoresheetData)
		var team1TotalPtsMatch = 0;
		var team2TotalPtsMatch = 0;
		var team1TotalPtsRound = 0;
		var team2TotalPtsRound = 0;
		var team1SumHandicap = 0;
		var team2SumHandicap = 0;
		var teamHandicap = 0;
		var team1TotalWins = 0;
		var team2TotalWins = 0;
		var matchPtsTeam1 = 0;
		var matchPtsTeam2 = 0;
		var team1TotalPtsHalfMatch = 0;
		var team2TotalPtsHalfMatch = 0;

		var rndPts = 1;
		var tournamentType = false
		tournamentType = (scoresheetData.resultsType === myConstClass.RESTYPE_TOURNAMENT);
		if(tournamentType) {
			rndPts = 0;
		}

		// ****************** HANDICAP ******************
		// calculate total handicap
		scoresheetData.playersHandicapTeam1.forEach(function(pHand) {
			// prevent unwanted undefined to alter the sum
			if (pHand === undefined) {pHand = 0}
			team1SumHandicap += pHand;	//parseInt(pHand, 10);
		});
		scoresheetData.playersHandicapTeam2.forEach(function(pHand) {
			// prevent unwanted undefined to alter the sum
			if (pHand === undefined) {pHand = 0}
			team2SumHandicap += pHand;	// parseInt(pHand, 10);
		});

		// absolute value
		teamHandicap = Math.abs(team1SumHandicap - team2SumHandicap);

/*
	Handicap Types: 
 	Aucun, Cote TRS, Cote SCAB, Parties, Moyenne, Moy-500
*/

		// cotes are 10, 20, 30, 40
		// "Moyenne" and Parties" are one for one
		if (scoresheetData.handicapType === "Cote TRS") {        // #HTYPE#
			teamHandicap = teamHandicap / 10;
		}
		else if (scoresheetData.handicapType === "Cote SCAB") {      // #HTYPE#
			teamHandicap = teamHandicap * 2;
		}

		// Apply maximum handicap
		var team1Handicap = 0;
		var team2Handicap = 0;

		if (teamHandicap > scoresheetData.handicapMax) {
			teamHandicap = scoresheetData.handicapMax;
		}
		if ((scoresheetData.handicapType === "Cote TRS") || (scoresheetData.handicapType === "Parties")) {
			if (team1SumHandicap > team2SumHandicap) {
				team1Handicap = teamHandicap;
			} else if (team2SumHandicap > team1SumHandicap) {
				team2Handicap = teamHandicap;
			}
		} else if ((scoresheetData.handicapType === "Moyenne") || (scoresheetData.handicapType === "Cote SCAB")) {
			if (team1SumHandicap > team2SumHandicap) {
				team2Handicap = teamHandicap;
			} else if (team2SumHandicap > team1SumHandicap) {
				team1Handicap = teamHandicap;
			}
		} else if (scoresheetData.handicapType === "Moy-500") {
			team1Handicap = 500 - team1SumHandicap;
			team2Handicap = 500 - team2SumHandicap;
		}

		// loop on rounds
		scoresheetData.rounds.forEach(function(round, roundIdx, rounds) {

			var team1RoundTotal = 0;
			var team2RoundTotal = 0;
			round.team1gamesWon = 0;
			round.team2gamesWon = 0;

			// loop on matchups
			round.matchups.forEach(function(matchup) {

				var p1Score = (parseInt(matchup.p1Score, 10) || 0);
				var p2Score = (parseInt(matchup.p2Score, 10) || 0);

				// ****************** Round Total ******************
				team1RoundTotal += p1Score;
				team2RoundTotal += p2Score;

				// for individual top gun leagues
				if (p1Score > p2Score) {
					round.team1gamesWon++;
					team1TotalWins++;
				}
				if (p2Score > p1Score) {
					round.team2gamesWon++;
					team2TotalWins++;
				}
			});

			// ****************** Round Total + Handicap ******************

			// Handicap per round
			if ((scoresheetData.handicapType === "Cote TRS") ||
				  (scoresheetData.handicapType === "Moyenne")) {

				team1RoundTotal = Math.round((team1RoundTotal + team1Handicap) * 100) / 100;
				team2RoundTotal = Math.round((team2RoundTotal + team2Handicap) * 100) / 100;

				// [2020-09-22] Correction applied here on team handicap
				// team handicap was not saved before the leagues starting on 2020-08-26 or before
				if (moment(scoresheetData.season.dateStart).isAfter("2020-08-15")) {
					round.team1Handicap = team1Handicap;
					round.team2Handicap = team2Handicap;
				}
			}

			round.team1Pts = team1RoundTotal;
			round.team2Pts = team2RoundTotal;

			team1TotalPtsMatch += team1RoundTotal;
			team2TotalPtsMatch += team2RoundTotal;

			team1TotalPtsHalfMatch += team1RoundTotal;
			team2TotalPtsHalfMatch += team2RoundTotal;

			// Standard or Individual Top Gun leagues ?
			if (scoresheetData.formatRoundPts === "WINS") {
				// Individual leagues Top Gun: round points calculated from victories
				if (round.team1gamesWon > round.team2gamesWon) {
					round.team1RoundPts = rndPts;
					round.team2RoundPts = 0;
				} else if (round.team2gamesWon > round.team1gamesWon) {
					round.team1RoundPts = 0;
					round.team2RoundPts = rndPts;
				} else {
					round.team1RoundPts = rndPts / 2;
					round.team2RoundPts = rndPts / 2;
				}
			} else if (scoresheetData.formatRoundPts === "POINTS") {
				// Standard leagues: round points calculated from points
				if (team1RoundTotal > team2RoundTotal) {
					round.team1RoundPts = rndPts;
					round.team2RoundPts = 0;
				} else if (team2RoundTotal > team1RoundTotal) {
					round.team1RoundPts = 0;
					round.team2RoundPts = rndPts;
				} else {
					round.team1RoundPts = rndPts / 2;
					round.team2RoundPts = rndPts / 2;
				}
			}

			team1TotalPtsRound += round.team1RoundPts;
			team2TotalPtsRound += round.team2RoundPts;

			// Point de mi-match and end of match
			if (scoresheetData.formatMatchPoint === "HALF MATCH POINTS") {

				if ((roundIdx === (Math.round(rounds.length / 2) - 1)) ||
				    (roundIdx === (rounds.length - 1))) {
					
					if (team1TotalPtsHalfMatch > team2TotalPtsHalfMatch) {
						matchPtsTeam1 += 1;
					} else if (team2TotalPtsHalfMatch > team1TotalPtsHalfMatch) {
						matchPtsTeam2 += 1;
					} else {
						matchPtsTeam1 += 0.5;
						matchPtsTeam2 += 0.5;
					}

					// reset totals
					team1TotalPtsHalfMatch = 0;
					team2TotalPtsHalfMatch = 0;
				}
			}
		}); // end of rounds.forEach


		// ****************** Round Total + Handicap + Match points ******************

		// Handicap per match
		if ((scoresheetData.handicapType === "Cote SCAB") ||
			  (scoresheetData.handicapType === "Parties") ||
			  (scoresheetData.handicapType === "Moy-500")) {
			team1TotalPtsMatch += team1Handicap;
			team2TotalPtsMatch += team2Handicap;
		}

		// Match point - POINTS
		if (scoresheetData.formatMatchPoint === "MATCH POINT (POINTS)") {
			if (team1TotalPtsMatch > team2TotalPtsMatch) {
				matchPtsTeam1 += 1;
			} else if (team2TotalPtsMatch > team1TotalPtsMatch) {
				matchPtsTeam2 += 1;
			} else {
				matchPtsTeam1 += 0.5;
				matchPtsTeam2 += 0.5;
			}
		}

		// Match point - WINS
		if (scoresheetData.formatMatchPoint === "MATCH POINT (WINS)") {
			if (team1TotalWins > team2TotalWins) {
				matchPtsTeam1 += 1;
			} else if (team2TotalWins > team1TotalWins) {
				matchPtsTeam2 += 1;
			} else {
				matchPtsTeam1 += 0.5;
				matchPtsTeam2 += 0.5;
			}
		}

		team1TotalPtsRound += matchPtsTeam1;
		team2TotalPtsRound += matchPtsTeam2;


		// ### NEW ###
		// Handicap for Top Gun leagues if so
		if (false) {
			// round.team1gamesWon += team1Handicap;
			// round.team2gamesWon += team2Handicap;

			//team1TotalWins += team1Handicap;
			//team2TotalWins += team2Handicap;
		}


		// ****************** TOTALS ******************
		// EXTRA ROUNDINGS to manage floats in JS
		scoresheetData.team1TotalPts = Math.round(team1TotalPtsMatch * 100) / 100;
		scoresheetData.team2TotalPts = Math.round(team2TotalPtsMatch * 100) / 100;
		scoresheetData.team1HandicapPts = Math.round(team1Handicap * 100) / 100;
		scoresheetData.team2HandicapPts = Math.round(team2Handicap * 100) / 100;
		scoresheetData.team1MatchPts = Math.round(matchPtsTeam1 * 100) / 100;
		scoresheetData.team2MatchPts = Math.round(matchPtsTeam2 * 100) / 100;
		scoresheetData.team1TotalRoundPts = Math.round(team1TotalPtsRound * 100) / 100;
		scoresheetData.team2TotalRoundPts = Math.round(team2TotalPtsRound * 100) / 100;
		scoresheetData.team1TotalWins = team1TotalWins;
		scoresheetData.team2TotalWins = team2TotalWins;

		this.setState({
			ssftype: scoresheetData.ssftype,
			scoresheetData: scoresheetData,
			scoreChanged: false
		});

		// console.log("updateScores")
		// console.log(scoresheetData)
		// console.log(team1Handicap)
		// console.log(team2Handicap)
		
		this.updateSpecialStats(scoresheetData);       
	}

	updateSpecialStats(scoresheetData) {
		var team1TotalEro = 0;
		var team2TotalEro = 0;
		var team1TotalTbb = 0;
		var team2TotalTbb = 0;
		var team1TotalTv = 0;
		var team2TotalTv = 0;

		// loop on rounds for ero/tv totals
		scoresheetData.rounds.forEach(function(round) {
			// loop on matchups
			round.matchups.forEach(function(matchup) {

				// ****************** ERO / TBB / TV ******************
				// default addigned to team 1
				if (matchup.ero) {

					// new qvnea stat, if ero, then automatically tv = true
					matchup.tv = true;

					if (matchup.p1Score < matchup.p2Score) {
						team2TotalEro += 1;
					} else {
						team1TotalEro += 1;
					}
				}
				if (matchup.tbb) {
					if (matchup.p1Score < matchup.p2Score) {
						team2TotalTbb += 1;
					} else {
						team1TotalTbb += 1;
					}
				}
				if (matchup.tv) {
					if (matchup.p1Score < matchup.p2Score) {
						team2TotalTv += 1;
					} else {
						team1TotalTv += 1;
					}
				}           
			});
		}); // end of rounds.forEach

		this.setState({
			team1TotalEro: team1TotalEro,
			team2TotalEro: team2TotalEro,
			team1TotalTbb: team1TotalTbb,
			team2TotalTbb: team2TotalTbb,
			team1TotalTv: team1TotalTv,
			team2TotalTv: team2TotalTv
		});
	}
	// ######################################################################################################################

	handleCompiledChange(e) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.compiled = e.target.checked;
		this.setState({
			scoresheetData: scoresheetData
		});
	}
	
	handleSaveClick() {
		var _this = this;
		var scoresheetData = this.state.scoresheetData;

		// -------------------------------------------------------------------
		// VALIDATION de base !
		var validationError = 0;
		scoresheetData.playersIdTeam1.forEach(function(teamId) {
			if (teamId === 0) {
				validationError = 1;
			}
		});
		scoresheetData.playersIdTeam2.forEach(function(teamId) {
			if (teamId === 0) {
				validationError = 2;
			}
		});

		if (validationError) {
			alert('ERREUR de validation - Équipe: ' + validationError + "\nJoueur invalide.\Feuille de pointage non-sauvegardée.")
			return;
		}

		// Prevent double sumbit of tournament
		if (this.state.savingInProgress) {
			console.log('saving rejected !');
			return;
		}

		// -----------------------------------------------------------------------------------------
		// Validation: TV or ERO with high PointsAgainst
		var validEroScoreOccurences = [];
		scoresheetData.rounds.forEach(sr => {
			sr.matchups.forEach(srm => {
				
				// [2023-06-15, v2.04.12a] Ero only now
				// if ((srm.ero === true) || (srm.tv === true)) {
				if (srm.ero === true) {
					if ((srm.p1Score === 10) && (srm.p2Score >= 4)) {
						validEroScoreOccurences.push({
							round: sr.roundNumber,
							matchup: srm.game,
							pointsAgainst: srm.p2Score
						});
					}
					if ((srm.p2Score === 10) && (srm.p1Score >= 4)) {
						validEroScoreOccurences.push({
							round: sr.roundNumber,
							matchup: srm.game,
							pointsAgainst: srm.p1Score
						});
					}
				}
			});
		});

		var confirmAns = "";
		if (validEroScoreOccurences.length > 0) {
			//var confirmMsg = "Un ou des matchs contiennent une TV ou un ERO avec des points contre assez élevé (plus grand que 10-3)";
			var confirmMsg = "Un ou des matchs contiennent un ERO avec des points contre assez élevé (plus grand que 10-3)";
			validEroScoreOccurences.forEach(veso => {
				confirmMsg += "\nRonde: " + veso.round + "  Match: " + veso.matchup + "  Pointage: 10-" + veso.pointsAgainst;
			});
			confirmMsg += "\n\nCliquer sur OK si c'est bien ce que vous vouliez entrer, ou sur Annuler pour vérifier et corriger les pointages erronés";
			confirmAns = window.confirm(confirmMsg);

			if (!confirmAns) {
				return;
			}
		}
		// -----------------------------------------------------------------------------------------


		this.setState({
			savingInProgress: true
		});

		//console.log('SAVING Scoresheet: scoresheetData')
		//console.log(scoresheetData)

		// added specialTable
		//console.log('scoresheetData.specialTable');
		//console.log(scoresheetData.specialTable);

		Axios.post('/api/scoresheets/', {
			scoresheetData: scoresheetData
		})
		.then(function(response) {
			if (response.data.configStringError) {
				alert("Erreur dans la chaîne de config (modification de programme).\n" + 
					"Attention au format à utiliser (ex: r1m2, r2m3, r3m4).\n" +
					"La chaîne de config n'a pas été prise en compte.");
			}
			// _this.props.loadScoresheetsTable();

			_this.setState({
				savingInProgress: false
			});

			_this.props.listScoresheets();
			console.log('Scoresheet saved !')
			window.scrollTo(0, 0);
		})
		.catch(function(error) {});
	}

	displayInstructions() {
		var winPoints = this.state.scoresheetData.scoresheetFormat.winPoints;
		if (this.state.scoresheetData.leagueType === myConstClass.LGTYPE_8B) {
			return ( 
				<div>
					<h5><b>Instructions pour les pointages</b></h5>
					<li> Entrer les pointages des joueurs (0 - {winPoints})</li>
					<li> Appuyer sur ENTER pour inscrire le pointage maximal ({this.state.scoresheetData.scoresheetFormat.winPoints}) </li>
					<li> Appuyer sur + pour inscrire un ERO facilement </li>
					<li> Sauvegarder vos changements ! </li>
				</div>
			);
		}

		if (this.state.scoresheetData.leagueType === myConstClass.LGTYPE_9B) {
			return ( 
				<div>
					<h5><b>Instructions pour les pointages</b></h5>
					<li> Entrer les pointages des joueurs</li>
					<li> Sauvegarder vos changements ! </li>
				</div>
			);
		}

		if (this.state.scoresheetData.leagueType === myConstClass.LGTYPE_10B) {
			return ( 
				<div>
					<h5><b>Instructions pour les pointages</b></h5>
					<li> Appuyer sur 1 ou 2 seulement pour identifier le joueur qui a gagné dans chaque match </li> 
					<li> Appuyer sur + pour inscrire un TRO facilement </li>
					<li> Sauvegarder vos changements ! </li>
				</div>
			);
		}
	}

	// ------------------------------------------------------------------------------------------------------------------------
	// ------------------------------------------------------------------------------------------------------------------------
	render() {
		//console.log('ScoresheetEdit: RENDER');
		//console.log(this.state.scoresheetData);
		//console.log(this.props);

		var scoresheetEditLabel = "Nouvelle feuille";
		if(this.state.scoresheetData.scoresheetEditId !== '0') {
			scoresheetEditLabel = "Modification";
		}

		var subseasonText = "Sous-saison";
		if(this.state.scoresheetData.resultsType === myConstClass.RESTYPE_TOURNAMENT) {
			subseasonText = "Sous-tournoi";
		}

		var seasonSpecial = "";
		if (this.state.scoresheetData.season.special != null) {
			seasonSpecial = this.state.scoresheetData.season.special;
		}


		if (this.state.scoresheetData.scoresheetFormat === null) {
			return (
				<div className="row">
				<div className="col-md-12">
					<br/>
					<p>Feuille de pointage non configurée - contactez Statelo</p>
					<br/>
				</div>
				</div>
			);
		} else {

		return (
			<div className="row">
			<div className="col-md-12">
			<br/><h5>Feuille de pointage - {scoresheetEditLabel}</h5>
			<br/>

			<form className="form-horizontal" onSubmit={this.handleSubmit}>

				<div className="row">
				<div className="col-md-5">

					{this.dispScoresheetTypeSelect()}
 
					<div className="form-group">
						<label className="labelSmallMarginBottom"> {subseasonText} </label>
						<div className="row">
						<div className="col-md-8">
						 <SubSeasonsDropdown value={this.state.scoresheetData.subSeasonId} subSeasons={this.state.scoresheetData.subSeasons} 
							subSeasonChange={this.subSeasonChange}></SubSeasonsDropdown>
						</div>
						</div>
					</div>

					<div className="form-group">
						<div className="row">
						<div className="col-md-4">
						<label className="labelSmallMarginBottom"> Programme </label>
						<WeeksDropdown week={this.state.scoresheetData.week} weekChange={this.weekChange} 
							numberOfWeeks={this.state.scoresheetData.nbMatchEq}></WeeksDropdown>
						</div>
						</div>
					</div>

					<div className="form-group">
						<label className="labelSmallMarginBottom"> Date </label>
						<div className="row">
						<div className="col-md-8">
						<input className="form-control" type="date" name="ssdate" value={this.state.scoresheetData.date || ''} 
							onChange={this.dateChange}></input>
						</div>
						</div>
					</div>

					<div className="form-group">
						<label className="labelSmallMarginBottom"> Type de Handicap </label>
						<div className="row">
						<div className="col-md-6">
						<HandicapTypeSelect handicapType={this.state.scoresheetData.handicapType} 
							handicapTypeChange={this.handicapTypeChange}/>
						</div>
						</div>
					</div>

					<div className="form-group">
						<label className="labelSmallMarginBottom"> Handicap Max </label>
						<div className="row">
						<div className="col-md-4">
						<input className="form-control" type="number" name="handicapMax" value={this.state.scoresheetData.handicapMax || 0} 
							onChange={this.handicapMaxChange}></input>
						</div>
						</div>
					</div>
				</div>

				<div className="col-md-7">
					<div className="form-group">
						{this.displayInstructions()}
					</div>
				</div>
				</div>

				<div className="row">
				<div className="col-md-5">

					<div className="form-group">
						<h5>Équipe 1: Local</h5>
						<div className="row">
						<div className="col-md-8">
						<TeamDropdown value={this.state.scoresheetData.team1Id} teams={this.state.scoresheetData.teams}
									  teamChange={this.activeTeamChange1} />
						</div>
						</div>
					</div>

					<div className="form-group">
						{this.state.scoresheetData.playersIdTeam1.map(this.createPlayerDropDownTeam1)}              
					</div>

					{/* if we split handicap, this should be removed */}
					<div className="form-group">
						<div className="row">
						<div className="col-md-12">
						<p><strong>Handicap Équipe 1:  {this.state.scoresheetData.team1HandicapPts}</strong></p>
						</div>
						</div>
					</div>

					<div className="form-group">
						<h5>Équipe 2: Visiteur</h5>
						<div className="row">
						<div className="col-md-8">
						<TeamDropdown value={this.state.scoresheetData.team2Id} teams={this.state.scoresheetData.teams}
									  teamChange={this.activeTeamChange2} />
						</div>
						</div>
					</div>

					<div className="form-group">
						{this.state.scoresheetData.playersIdTeam2.map(this.createPlayerDropDownTeam2)}              
					</div>

					{/* if we split handicap, this should be removed */}
					<div className="form-group">
						<div className="row">
						<div className="col-md-12">
						<p><strong>Handicap Équipe 2:  {this.state.scoresheetData.team2HandicapPts}</strong></p>
						</div>
						</div>
					</div>
					
					{this.displayScoreboard()}
					{this.dispCompiledButton()}

					<input type="button" className="btn btn-primary" value="Sauvegarder la feuille de pointage" onClick={this.handleSaveClick} />
					<hr/>
					<br/>

					{this.savingModal()}
				</div>

				<div className="col-md-7">

          <input type="button" className="btn btn-primary btn-sm btn-margin-right-10" 
          	value="Ordonner - Équipe A" onClick={this.orderTeam.bind(this, 'A')} />
          <input type="button" className="btn btn-primary btn-sm" 
          	value="Ordonner - Équipe B" onClick={this.orderTeam.bind(this, 'B')} />
          <br/>
          <p>Pointages ordonnés pour l'équipe: {this.state.teamOrder}</p>
          <br/>

					{/* if we split handicap, this would change, send round.handicap to RoundScore */}
					{/* have a function prop to handle the change */}
					{this.state.scoresheetData.rounds.map(function (round, i) {
						return (
							<RoundScore key={"round"+i} round={round} 
								handleScoreChange={this.handleScoreChange} handleScoreBlur={this.handleScoreBlur}
								handicapType={this.state.scoresheetData.handicapType}
								team1HandicapPts={this.state.scoresheetData.team1HandicapPts} team2HandicapPts={this.state.scoresheetData.team2HandicapPts} 
								handleEroChange={this.eroChange} handleTbbChange={this.tbbChange} handleTvChange={this.tvChange}
								handleKeyPress={this.scoreKeyPress}
								leagueType={this.state.scoresheetData.leagueType}
								stateloLeagueParam={this.state.scoresheetData.stateloLeagueParam}
								teamOrder={this.state.teamOrder}
								allRounds={this.state.scoresheetData.rounds} roundIdx={i}>
							</RoundScore>
						);
					}, this )
					}

				</div>
				</div>
			</form>

			<hr/>
			{(seasonSpecial.indexOf('EXTRAPLAYER') !== -1) ? 
				this.dispSpecialPanel() : null}

			</div>
			</div>
		);
		}
	}

	orderTeam(teamOrder) {
		this.setState({teamOrder: teamOrder});
	}

	dispScoresheetTypeSelect() {

		if (this.state.scoresheetData.season.multipleScoresheetFormats) {
			return (
				<div className="form-group">
				<div className="row">
				<div className="col-md-4">
				<label className="labelSmallMarginBottom"> Scoresheet Type </label>
				<input className="form-control" type="number" name="ssftype" 
					value={this.state.ssftype || 0} 
					onChange={this.ssfTypeChange}></input>
				</div>
				</div>
				</div>
			);
		}
	}

	displayScoreboard() {
		// Scoreboard display is conditionnal
		if (this.state.scoresheetData.leagueType === myConstClass.LGTYPE_8B) {
			return (
				<Scoreboard_8B rounds={this.state.scoresheetData.rounds} 
					team1MatchPts={this.state.scoresheetData.team1MatchPts} team2MatchPts={this.state.scoresheetData.team2MatchPts} 
					team1TotalPts={this.state.scoresheetData.team1TotalPts} team2TotalPts={this.state.scoresheetData.team2TotalPts} 
					team1TotalRoundPts={this.state.scoresheetData.team1TotalRoundPts} team2TotalRoundPts={this.state.scoresheetData.team2TotalRoundPts}
					team1TotalWins={this.state.scoresheetData.team1TotalWins} team2TotalWins={this.state.scoresheetData.team2TotalWins}
					handicapType={this.state.scoresheetData.handicapType}
					team1HandicapPts={this.state.scoresheetData.team1HandicapPts} 
					team2HandicapPts={this.state.scoresheetData.team2HandicapPts}
					team1TotalEro={this.state.team1TotalEro} team2TotalEro={this.state.team2TotalEro}
					team1TotalTv={this.state.team1TotalTv} team2TotalTv={this.state.team2TotalTv} 
					stateloLeagueParam={this.state.scoresheetData.stateloLeagueParam}
					resultsType={this.state.scoresheetData.resultsType} 
					formatMatchPoint={this.state.scoresheetData.formatMatchPoint}
					formatMatchType={this.state.scoresheetData.formatMatchType} >
				</Scoreboard_8B>
			);
		}
		if (this.state.scoresheetData.leagueType === myConstClass.LGTYPE_9B) {
			return (
				<Scoreboard_9B rounds={this.state.scoresheetData.rounds} 
					team1MatchPts={this.state.scoresheetData.team1MatchPts} team2MatchPts={this.state.scoresheetData.team2MatchPts} 
					team1TotalPts={this.state.scoresheetData.team1TotalPts} team2TotalPts={this.state.scoresheetData.team2TotalPts} 
					team1TotalRoundPts={this.state.scoresheetData.team1TotalRoundPts} team2TotalRoundPts={this.state.scoresheetData.team2TotalRoundPts}
					team1TotalWins={this.state.scoresheetData.team1TotalWins} team2TotalWins={this.state.scoresheetData.team2TotalWins}
					handicapType={this.state.scoresheetData.handicapType}
					team1HandicapPts={this.state.scoresheetData.team1HandicapPts} 
					team2HandicapPts={this.state.scoresheetData.team2HandicapPts}
					stateloLeagueParam={this.state.scoresheetData.stateloLeagueParam}
					resultsType={this.state.scoresheetData.resultsType} 
					formatMatchPoint={this.state.scoresheetData.formatMatchPoint}
					formatMatchType={this.state.scoresheetData.formatMatchType} >
				</Scoreboard_9B>
			);
		}
		if(this.state.scoresheetData.leagueType === myConstClass.LGTYPE_10B) {
			return (
				<Scoreboard_10B rounds={this.state.scoresheetData.rounds} 
					team1MatchPts={this.state.scoresheetData.team1MatchPts} team2MatchPts={this.state.scoresheetData.team2MatchPts} 
					team1TotalPts={this.state.scoresheetData.team1TotalPts} team2TotalPts={this.state.scoresheetData.team2TotalPts} 
					team1TotalPts={this.state.scoresheetData.team1TotalPts} team2TotalPts={this.state.scoresheetData.team2TotalPts}
					team1TotalWins={this.state.scoresheetData.team1TotalWins} team2TotalWins={this.state.scoresheetData.team2TotalWins}
					handicapType={this.state.scoresheetData.handicapType}
					team1HandicapPts={this.state.scoresheetData.team1HandicapPts} 
					team2HandicapPts={this.state.scoresheetData.team2HandicapPts}
					team1TotalEro={this.state.team1TotalEro} team2TotalEro={this.state.team2TotalEro}
					team1TotalTbb={this.state.team1TotalTbb} team2TotalTbb={this.state.team2TotalTbb}
					formatMatchType={this.state.scoresheetData.formatMatchType} >
				</Scoreboard_10B>
			);
		}
		else {
			return;
		}
	}

	dispCompiledButton() {
		return (
			<div className="row col-md-12">
				<label className="switch switch-3d switch-success">
					<input type="checkbox" className="switch-input" checked={this.state.scoresheetData.compiled || false} 
						onChange={this.handleCompiledChange}/>
					<span className="switch-label"></span>
					<span className="switch-handle"></span>
				</label>
				&nbsp;&nbsp;Compiler cette feuille
			</div>
		);
	}

	createPlayerDropDownTeam1(playerId, i) {
		var playerNumber = i + 1;
		return (
			<div key={'dp1_'+ playerNumber}>
				{"A"+playerNumber} &nbsp; 
				<PlayersDropdownScoresheet key={'p.1.'+ playerNumber} playerNumber={'p.1.'+ playerNumber} 
					value={this.state.scoresheetData.playersIdTeam1[i]} players={this.state.scoresheetData.playersTeam1} 
					handlePlayerChange={this.playerChange} handicap={this.state.scoresheetData.playersHandicapTeam1[i]} 
					handleHandicapChange={this.handicapChange} subPlayers={this.state.scoresheetData.subPlayers[0]} />
			</div>
		);
	}

	createPlayerDropDownTeam2(playerId, i) {
		var playerNumber = i + 1;
		return (
			<div key={'dp2_'+ playerNumber}>
				{"B"+playerNumber} &nbsp; 
				<PlayersDropdownScoresheet key={'p.2.'+ playerNumber} playerNumber={'p.2.'+ playerNumber} 
					value={this.state.scoresheetData.playersIdTeam2[i]} players={this.state.scoresheetData.playersTeam2} 
					handlePlayerChange={this.playerChange} handicap={this.state.scoresheetData.playersHandicapTeam2[i]} 
					handleHandicapChange={this.handicapChange} subPlayers={this.state.scoresheetData.subPlayers[1]} />
			</div>
		);
	}

	savingModal() {
		return (
			<Modal 
				isOpen={this.state.savingInProgress} size="sm"
				className={this.props.className}>
				<ModalHeader>
					Sauvegarde en cours
				</ModalHeader>
				<ModalBody>
					<p>Veuillez patienter...</p>
				</ModalBody>
      </Modal>
    )
	}

	// Special Table to change matchups after teams are automatically generated
	dispSpecialPanel() {
		return (
			<div className="row">
			<div className="col-md-9">

				<h5>Spécial - Modification de programme</h5>
				<input type="button" className="btn btn-primary btn-sm btn-extra-padding" value="Ajouter une ligne-joueur" 
					onClick={this.handleAddSpecialTableEntry} />

				<div className="table-responsive">
				<table className="table table-hover table-sm">
				<thead>
					<tr>
						<th>Équipe</th>
						<th>Joueur</th>
						<th>Chaîne de config (rXmY,rXmY,...)</th>
						<th>Supprimer</th>
					</tr>
				</thead>
				<tbody>
				{this.state.scoresheetData.specialTable.map(this.createSpecialTableRow)}
				</tbody>
				</table>

				<p>La chaîne de config doit avoir le format suivant (r1m2,r2m3,r3m4) où le chiffre qui suit 
					le 'r' est le numéro de la ronde (1, 2, 3, ...) et le chiffre qui suit le 'm' est le numéro 
					du match (1, 2, 3, ...).  Pour chaque endroit où le joueur sélectionné remplace le joueur actuel, 
					il doit y avoir une séquence rXmY.  Séparer les rXmY par des virgules.</p>
			</div>

			</div>
			</div>
		)
	}

  createSpecialTableRow(row, rowIdx, rows) {
  	var playersTeam = [];
  	var subPlayers = [];
  	if (row.team === 1) {
  		playersTeam = this.state.scoresheetData.playersTeam1;
  		subPlayers = this.state.scoresheetData.subPlayers[0];
  	}
  	if (row.team === 2) {
  		playersTeam = this.state.scoresheetData.playersTeam2;
  		subPlayers = this.state.scoresheetData.subPlayers[1];
  	}

    return (
      <tr key={'spt.' + rowIdx}>
        <td>
					<input type="number"  min="1" max="2" className="form-control-sm" name="specialTeam" id="specialTeam"  
						value={row.team || 1} onChange={this.handleSpecialTeamChange.bind(this, rowIdx)} />
				</td>
        <td>
        	{/*row.playerId*/}
					 <select className="form-control form-control-sm" value={row.playerId} 
						onChange={this.handleSpecialTablePlayerChange.bind(this, rowIdx)}>
						{playersTeam.map(this.specialTableCreatePlayerItem)}
						<option disabled>───── substituts ─────</option>
						{subPlayers.map(this.specialTableCreatePlayerItem)}
					</select>
				</td>

        <td>
					<input type="text" className="form-control-sm" name="configString" id="name"  
						value={row.configString || ''} onChange={this.handleConfigStringChange.bind(this, rowIdx)} /> 
				</td>

				<td> <input name={'delete.' + rowIdx} type="button" onClick={this.handleDeleteSpecialTableRow.bind(this, rowIdx)} value="Supprimer"/> </td>
      </tr>
    );
	}

	specialTableCreatePlayerItem(player, idx) {
		return (
			<option value={player.playerId} key={'pds'+ idx}> {player.name} </option>
		);
	}

	handleAddSpecialTableEntry() {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.specialTable.push({team: 1,	playerId: this.state.scoresheetData.playersTeam1[0].playerId, configString: ""});
		this.setState({scoresheetData: scoresheetData});
	}

	handleDeleteSpecialTableRow(rowIdx) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.specialTable.splice(rowIdx, 1)
		this.setState({scoresheetData: scoresheetData});
	}

	handleSpecialTeamChange(rowIdx, e) {
		var scoresheetData = this.state.scoresheetData;

		var teamIdx = parseInt(e.target.value, 10);
		var playerId = this.state.scoresheetData.playersTeam1[0].playerId;
		if (teamIdx === 2) {
			playerId = this.state.scoresheetData.playersTeam2[0].playerId;
		}

		scoresheetData.specialTable[rowIdx] = {
			team: teamIdx, 
			playerId: playerId, 
			configString: ""
		};
		this.setState({scoresheetData: scoresheetData});
	}

	handleConfigStringChange(rowIdx, e) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.specialTable[rowIdx].configString = e.target.value;
		this.setState({scoresheetData: scoresheetData});
	}

	handleSpecialTablePlayerChange(rowIdx, e) {
		var scoresheetData = this.state.scoresheetData;
		scoresheetData.specialTable[rowIdx].playerId = e.target.value;
		this.setState({scoresheetData: scoresheetData});
	}

}

export default ScoresheetEdit;